const findArrayinJSON = (obj: unknown): unknown[] | null => {
  if (Array.isArray(obj)) return obj;
  if (typeof obj === 'object' && obj !== null) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const result = findArrayinJSON((obj as Record<string, unknown>)[key]);
      if (result) return result;
    }
  }
  return null;
};

export default findArrayinJSON;
